import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';

type Params = {
  disableSuccessAlert?: boolean;
};

type Req = {
  contactId: number;
  customerId: number;
};

type Return = {
  addCustomerContact: (req: Req) => Promise<void>;
  isAdding: boolean;
  isErrorAdding: boolean;
};

export const useAddCustomerContact = (params?: Params): Return => {
  const { customersApi } = useApiClient();

  const { isError, isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    meta: { disableSuccessAlert: params?.disableSuccessAlert },
    mutationFn: async req => {
      await customersApi.addCustomerContact(req.customerId, req.contactId);
    },
  });

  return {
    addCustomerContact: mutateAsync,
    isAdding: isPending,
    isErrorAdding: isError,
  };
};
